import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import type {NutshellState} from '../../store';

import {accountRefetchForEvent} from '../peep/account/hooks/use-account-update-refetch';

import {useAddPdlContactsToAccount} from './graphql/hooks/use-add-pdl-contacts-to-account';
import {useUpdatePeopleIqPreference} from './graphql/hooks/use-update-people-iq-preference';
import {PeopleIqSidebar} from './people-iq-sidebar';
import {closeSidebar, dismissForAccount} from './redux/actions';
import * as selectors from './redux/selectors';

export function PeopleIqSidebarWrapper() {
    const accountId = useSelector((state: NutshellState) => selectors.getAccountId(state));
    const companyName = useSelector((state: NutshellState) => selectors.getAccountName(state));
    const contacts = useSelector((state: NutshellState) => selectors.getContacts(state));
    const leadId = useSelector((state: NutshellState) => selectors.getLeadId(state));

    const dispatch = useDispatch();
    const {updatePeopleIqPreference} = useUpdatePeopleIqPreference();
    const {addContacts} = useAddPdlContactsToAccount();

    const onCloseSidebar = () => {
        dispatch(closeSidebar());
    };

    const closeSidebarAndHideBadge = () => {
        onCloseSidebar();
        dispatch(dismissForAccount({accountId}));
    };

    const closeSidebarAndRefetchPage = () => {
        onCloseSidebar();
        accountRefetchForEvent('accountContactsUpdated');
        $('body').trigger(Nut.events.global.accountContactsWereUpdated);
    };

    const onHideFutureRecommendations = () => {
        updatePeopleIqPreference({
            accountId: accountId,
            preference: 'DECLINED',
        }).then(closeSidebarAndHideBadge);
    };

    const onAddContacts = (contactIds: string[]) => {
        addContacts({
            pdlContactIds: contactIds,
            accountId,
            leadId,
        }).then(closeSidebarAndRefetchPage);
    };

    if (
        !companyName ||
        !contacts ||
        !contacts.length ||
        !onHideFutureRecommendations ||
        !onAddContacts
    ) {
        return null;
    }

    return (
        <PeopleIqSidebar
            companyName={companyName}
            contacts={contacts}
            onHideFutureRecommendations={onHideFutureRecommendations}
            onAddContacts={onAddContacts}
            onClose={onCloseSidebar}
        />
    );
}
